import React, {Component} from 'react';
import BsySlidePane from "../BsySlidePane";
import BsyWebhookLogPane from "../BsyWebhookLogPane";
import BsyWebhookEventMenu from "../BsyWebhookEventMenu";
import BsyDashboardMenu from "../dashboard/BsyDashboardMenu";
import BsyWebhookDoc from "../BsyWebhookDoc";
import wushujutuisong from "../../images/img_wushujutuisong@2x.png";
import imgkfptweihuoqu from "../../images/img_kfpt_weihuoqu@2x.png";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import {NavLink} from "react-router-dom";
import DocumentTitle from "react-document-title";

class BsyWebhookContacts extends Component {
    constructor(props) {
        super(props);
        this.serverVal = React.createRef();
    }

    componentDidMount() {
        this.loadWebHook()
    }

    loadWebHook = () =>{
        this.setState({success:false})
        React.axios("/webhook/info",{
            type:1
        }).then((res)=>{
            this.setState({list:res.data.data,openapi:res.data.openapi,success:true})
        })
    }

    state = {
        eventType: 1,
        form:{},
        success:false,
        list:[]
    }
    openWebHookLog = (val) =>{
        return ()=>{
            const {openapi} = this.state
            BsySlidePane({
                title: React.language('data.api.log'),
                hasHeader: true,
                onContentCreate: (ref) => {
                    return <BsyWebhookLogPane id={val.id} openapi={openapi} status={val.status} />
                },
            })
        }
    }

    randomWord = (randomFlag, min, max) =>{
        let str = "",
            range = min,
            arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

        // 随机产生
        if(randomFlag){
            range = Math.round(Math.random() * (max-min)) + min;
        }
        for(let i=0; i<range; i++){
            let pos = Math.round(Math.random() * (arr.length-1));
            str += arr[pos];
        }
        this.secret = str;
        return str;
    }

    createSecret = (event) =>{
        event.currentTarget.parentNode.getElementsByTagName("input")[0].value = this.randomWord(false,24)
    }

    getPopupValue = (ref) =>{
        this.value = ref
    }

    secretChange = (event) =>{
        this.secret = event.currentTarget.value;
    }

    testServer = () =>{
        var reg=/^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)([\w.]+\/?)\S*/;
        if(!reg.test(this.serverVal.current.value)){
            tipAlert({
                type: 'warning',
                msg: React.language('server.url.tip')
            })
            return
        }

        React.axios("/webhook/pingurl",{
            url:this.serverVal.current.value
        }).then((res)=>{
            if(res.data.data.status_code === 200){
                tipAlert({
                    type:"success",
                    msg:React.language('url.server.tip1')
                })
            }else{
                tipAlert({
                    type:"error",
                    msg:React.language('url.server.tip2',{code:res.data.data.status_code})
                })
            }
        })
    }


    createWebHook = (d) =>{
        return ()=>{
            let form = d ? d : this.state.form;
            if(d){
                this.secret = d.encrypt_key;
            }
            BsySlidePane({
                title: React.language('data.api'),
                hasHeader: true,
                onContentCreate: (ref) => {
                    return <div className="OpenContent" key={form.formid}>
                        <div className="content-body">
                            <div className="content">
                                <div className="open-server">
                                    <div className="open-title"><span>{React.language('data.api.serverUrl.config')}</span></div>
                                    <div className="open-cont">
                                        <div className="cont-server"><input maxLength={255} placeholder={React.language('server.url.tip1')} defaultValue={form.url} ref={this.serverVal} type="text" id="open-server-val"/>
                                            <div className="cont-btn" onClick={this.testServer}>{React.language('data.api.server.test')}</div></div>
                                    </div>
                                </div>
                                <div className="open-secret">
                                    <div className="open-title"><span>Secret</span></div>
                                    <div className="open-cont">
                                        <div className="cont-secret"><input defaultValue={form.encrypt_key} onChange={this.secretChange} type="text" id="open-secret-val" maxLength={24}/>
                                            <div className="cont-btn" onClick={this.createSecret}>{React.language('data.api.secret.create')}</div></div>
                                    </div>
                                </div>
                                <div className="open-event">
                                    <div className="open-title"><span>{React.language('push.event')}</span></div>
                                    <div className="open-cont">
                                        <BsyWebhookEventMenu />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="content-footer">
                            <div className="open-btn-save" onClick={this.onSave(ref,d)}><span>{React.language('save')}</span></div>
                        </div>
                    </div>
                },
            })
        }
    }
    onSave = (ref,d) =>{
        return () =>{
            if(!this.serverVal.current.value){
                tipAlert({
                    type: 'warning',
                    msg: React.language('data.api.server.target')
                })
                return
            }

            var reg=/^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)([\w.]+\/?)\S*/;
            if(!reg.test(this.serverVal.current.value)){
                tipAlert({
                    type: 'warning',
                    msg: React.language('server.url.tip')
                })
                return
            }


            let params =d ? {
                "type":1, //类型  表单数据推送值为 2 通讯录推送为 1
                "id": d.id, //推送对应的唯一id
                "status":d.status, //状态
                "url":this.serverVal.current.value, //地址
                "encrypt_key": this.secret //加密字符串
            }:{
                "type":1, //类型  表单数据推送值为 2 通讯录推送为 1
                "url":this.serverVal.current.value, //地址
                "encrypt_key": this.secret //加密字符串
            }

            React.axios("/webhook/update",{
                ...params
            }).then((res)=>{
                if(res.data.errcode === 1){
                    tipAlert({
                        type:"error",
                        msg:res.data.errmsg
                    })
                    return
                }
                this.secret = "";
                this.serverVal.current.value = "";
                this.loadWebHook()
                ref.closeAlter()
            })
        }
    }

    switchStatus = (val) =>{
        return (event)=>{
            const e = event.currentTarget;
            const t = this;
            val.type = 1;
            window.FX.Msg.alert({
                type: "query",
                title:  val.status === 0 ? React.language("activated.webhook.tip") : React.language("deactivated.webhook.tip"),
                msg:  val.status === 0 ? React.language("activated.webhook.tip1") : React.language("deactivated.webhook.tip1"),
                text4Ok: val.status === 0 ? React.language('enable') : React.language('deactivate'),
                onOk: function () {
                    if(val.status === 0) {
                        val.status = 1;
                    }else {
                        val.status = 0;
                    }
                    React.axios("/webhook/update",{
                        ...val
                    }).then((res)=>{
                        if(res.data.errcode === 1){
                            tipAlert({
                                type:"error",
                                msg:res.data.errmsg
                            })
                            return
                        }
                        if(val.status === 0){
                            val.status = 1;
                            e.getElementsByTagName("span")[0].classList.add("green")
                            e.getElementsByTagName("span")[0].innerText = React.language('enable')
                        }else{
                            val.status = 0;
                            e.getElementsByTagName("span")[0].classList.remove("green")
                            e.getElementsByTagName("span")[0].innerText = React.language('deactivate')
                        }
                        t.loadWebHook()
                    })
                }
            });
        }
    }
    deleteWebhook = (d) =>{
        return (event)=>{
            const e = event.currentTarget;
            const t = this;
            window.FX.Msg.alert({
                type: "warning",
                title:  React.language("delete.webhook.tip"),
                msg:  React.language("delete.webhook.tip1"),
                text4Ok: React.language('delete'),
                onOk: function () {
                    React.axios("/webhook/delete",{
                        id:d.id
                    }).then((res)=>{
                        e.parentNode.parentNode.parentNode.parentNode.remove();
                    })
                }
            });
        }
    }

    openDocForm = (d) =>{
        return ()=>{
            BsySlidePane({
                title: React.language('data.api.doc.title'),
                hasHeader: true,
                onContentCreate: (ref) => {
                    return <BsyWebhookDoc data={d} type={1}/>
                },
            })
        }
    }

    againPush = (d) =>{
        return (event)=>{
            const e = event.currentTarget;
            window.FX.Msg.alert({
                type: "query",
                title:  React.language("retry.webhook.tip"),
                text4Ok: React.language('ok'),
                onOk: function () {
                    React.axios("/webhook/retry",{
                        id:d.id
                    }).then((res)=>{
                        tipAlert({
                            type: 'success',
                            msg: React.language('retry.webhook.tip1')
                        })
                        e.parentNode.parentNode.remove()
                    })
                }
            });
        }
    }

    discardPush = (d) =>{
        return (event)=>{
            const e = event.currentTarget;
            window.FX.Msg.alert({
                type: "query",
                title:  React.language("abandon.webhook.tip"),
                text4Ok: React.language('ok'),
                onOk: function () {
                    React.axios("/webhook/abandon",{
                        id:d.id
                    }).then((res)=>{
                        e.parentNode.parentNode.remove()
                    })
                }
            });
        }
    }

    leftTitle = () =>{
        return <div className="leftTitle">
            <span>{React.language('open.platform')}</span>
        </div>
    }

    dashboardMenuCenterMenu = () =>{
        return <div className="open-header">
            <NavLink activeClassName="select" className="api-webhook" to={window.rootDirectroy + "/open/api"}>
                <div className="header-btn"><span>api</span></div>
            </NavLink>
            <NavLink activeClassName="select" className="key-webhook" to={window.rootDirectroy + "/open/key"}>
                <div className="header-btn"><span>{React.language('key.management')}</span></div>
            </NavLink>
            <NavLink activeClassName="select" className="address-webhook" to={window.rootDirectroy + "/open/webhook"}>
                <div className="header-btn"><span>webhook</span></div>
            </NavLink>
            <NavLink activeClassName="select" className="modules-webhook" to={window.rootDirectroy + "/open/modules"}>
                <div className="header-btn"><span>{React.language('module')}</span></div>
            </NavLink>
            {window.FX.STATIC["user_corps"]["mode"] === "common" && <NavLink activeClassName="select" className="sso-webhook" to={window.rootDirectroy + "/open/sso"}>
                <div className="header-btn"><span>{React.language('account.signin.sso')}</span></div>
            </NavLink>}
        </div>
    }

    render() {
        const {list,openapi,success} = this.state;
        let enableList = [];
        let pauseList = [];
        list.map((val)=>{
            if(val.status === 1){
                enableList.push(val)
            }else if(val.status === 0){
                pauseList.push(val)
            }
        })
        return (
                <div className="BsyWebhookPane">
                    {success && <div className="open-pane">
                        {list.length > 0 ? <div className="openList">
                            <div className="enableOpenList">
                                <div className="openListTitle">
                                    <div className="open-state"><i
                                        className="icon-webhook-enable"/><span>{React.language('activated.setting')}</span>
                                    </div>
                                    <div className="title-create">
                                        {openapi && <div className="createBtn" onClick={this.createWebHook()}><i
                                            className="icon-bsy-add"/><span>{React.language('create')}</span></div>}
                                    </div>
                                </div>
                                <ul>
                                    {
                                        enableList.length > 0 && enableList.map((val) => {
                                            return val.status === 1 && <li>
                                                <div className="webhook-content-body-list">
                                                    <div className="headerItem">
                                                        <div className="headerLeft">
                                                            <div className="webhook-log">
                                                                <div className="log-btn" onClick={this.openWebHookLog(val)}>
                                                                    <span>{React.language('data.api.log')}</span></div>
                                                            </div>
                                                        </div>
                                                        <div className="headerOptions">
                                                            <div className="headerOptionsLeft">
                                                                <div className="optBtn" onClick={this.openDocForm(val)}>
                                                                    <span>{React.language('data.api.doc.title')}</span>
                                                                </div>
                                                            </div>
                                                            <div className="headerOptionsRight">
                                                                {openapi && <div className="optBtn"
                                                                                   onClick={this.switchStatus(val)}><span
                                                                    className={val.status === 0 ? "green" : ""}>{React.language('deactivate')}</span>
                                                                </div>}
                                                                {openapi &&
                                                                <div className="optBtn edit" onClick={this.createWebHook(val)}>
                                                                    <span>{React.language('edit')}</span></div>}
                                                                <div className="optBtn" onClick={this.deleteWebhook(val)}>
                                                                    <span>{React.language('delete')}</span></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="contItem">
                                                        <div className="server-cont">
                                                            <span>{React.language('data.api.serverUrl')}</span>
                                                            <b>{val.url}</b>
                                                        </div>
                                                        {val.fail !== 0 && <div className="webhook-error-detail">
                                                            <div
                                                                className="error-detail">{React.language('data.api.fail.tip1', {count: val.fail})}</div>
                                                            {openapi && <div className="error-btn">
                                                                <div className="optBtn" onClick={this.againPush(val)}>
                                                                    <span>{React.language('data.api.push.again')}</span>
                                                                </div>
                                                                <div className="optBtn" onClick={this.discardPush(val)}>
                                                                    <span>{React.language('data.api.push.discard')}</span>
                                                                </div>
                                                            </div>}
                                                        </div>}
                                                    </div>
                                                </div>
                                            </li>
                                        })
                                    }
                                </ul>
                            </div>
                            {pauseList.length > 0 && <div className="pauseOpenList">
                                <div className="openListTitle">
                                    <div className="open-state"><i
                                        className="icon-webhook-deactivate"/><span>{React.language('stoped.setting')}</span>
                                    </div>
                                </div>
                                <ul>
                                    {
                                        pauseList.length > 0 && pauseList.map((val) => {
                                            return val.status === 0 && <li>
                                                <div className="webhook-content-body-list">
                                                    <div className="headerItem">
                                                        <div className="headerLeft">
                                                            <div className="webhook-log">
                                                                <div className="log-btn" onClick={this.openWebHookLog(val)}>
                                                                    <span>{React.language('data.api.log')}</span></div>
                                                            </div>
                                                        </div>
                                                        <div className="headerOptions">
                                                            <div className="headerOptionsLeft">
                                                                <div className="optBtn" onClick={this.openDocForm(val)}>
                                                                    <span>{React.language('data.api.doc.title')}</span>
                                                                </div>
                                                            </div>
                                                            <div className="headerOptionsRight">
                                                                {openapi &&
                                                                <div className="optBtn"
                                                                     onClick={this.switchStatus(val)}><span
                                                                    className={val.status === 0 ? "green" : ""}>{React.language('enable')}</span>
                                                                </div>}
                                                                {openapi &&
                                                                <div className="optBtn edit" onClick={this.createWebHook(val)}>
                                                                    <span>{React.language('edit')}</span></div>}
                                                                <div className="optBtn" onClick={this.deleteWebhook(val)}>
                                                                    <span>{React.language('delete')}</span></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="contItem">
                                                        <div className="server-cont">
                                                            <span>{React.language('data.api.serverUrl')}</span>
                                                            <b>{val.url}</b>
                                                        </div>
                                                        {val.fail !== 0 && <div className="webhook-error-detail">
                                                            <div
                                                                className="error-detail">{React.language('data.api.fail.tip1', {count: val.fail})}</div>
                                                            {openapi && <div className="error-btn">
                                                                <div className="optBtn" onClick={this.againPush(val)}>
                                                                    <span>{React.language('data.api.push.again')}</span>
                                                                </div>
                                                                <div className="optBtn" onClick={this.discardPush(val)}>
                                                                    <span>{React.language('data.api.push.discard')}</span>
                                                                </div>
                                                            </div>}
                                                        </div>}
                                                    </div>
                                                </div>
                                            </li>
                                        })
                                    }
                                </ul>
                            </div>}
                        </div> : <div className="openListEmpty">
                            <div className="emptyCont">
                                <div className="emptyImg">
                                    <img style={{width:openapi ? "108px" : "260px"}} src={openapi ? wushujutuisong : imgkfptweihuoqu} alt=""/>
                                </div>
                                <div className="emptyTip">
                                    <span>{openapi ? React.language("open.platform.empty.tip") : React.language("purview.webhook.tip1")}</span>
                                </div>
                                <div className="emptyBtn">
                                    {openapi && <div className="emptyCreateBtn" onClick={this.createWebHook()}>
                                        <span>{React.language("data.api.create")}</span>
                                    </div>}
                                </div>
                            </div>
                        </div>}
                    </div>}
                </div>
        );
    }
}

export default BsyWebhookContacts;